import curry from "./curry.js";

export default curry(function subtract(a, b) {
  return a - b;
});
